import { defineComponent, openBlock, createElementBlock, mergeProps, unref, createElementVNode, normalizeClass, normalizeStyle, withDirectives, toHandlers, vModelDynamic } from 'vue';
import { UiStepsInputPropsOption, UiStepsInputEmits } from './index.mjs';
import { useComposable } from './src/composable.mjs';

const __default__ = defineComponent({ name: "UiStepsInput" });
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: UiStepsInputPropsOption,
  emits: UiStepsInputEmits,
  setup(__props, { emit: __emit }) {
    const define = __props;
    const emits = __emit;
    const { ons, refs, binds, computeds } = useComposable(define, emits);
    const { currentPage } = refs;
    const { style } = computeds;
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(
        "div",
        mergeProps({ class: "ui-steps-input" }, unref(binds).container),
        [
          createElementVNode(
            "div",
            {
              class: normalizeClass(["ui-steps-container", { "ui-active": unref(currentPage) == "start" }]),
              style: normalizeStyle(unref(style))
            },
            [
              withDirectives(createElementVNode(
                "input",
                mergeProps({
                  class: "ui-form-control ui-steps-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.modelValue.start = $event)
                }, unref(binds).input.start, toHandlers(unref(ons).start, true)),
                null,
                16
                /* FULL_PROPS */
              ), [
                [vModelDynamic, _ctx.modelValue.start]
              ]),
              withDirectives(createElementVNode(
                "input",
                mergeProps({
                  class: "ui-form-control ui-steps-number",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.modelValue["start-steps"] = $event)
                }, unref(binds).number, toHandlers(unref(ons).start, true)),
                null,
                16
                /* FULL_PROPS */
              ), [
                [vModelDynamic, _ctx.modelValue["start-steps"]]
              ])
            ],
            6
            /* CLASS, STYLE */
          ),
          createElementVNode(
            "div",
            mergeProps({ class: "ui-steps-rect" }, unref(binds).rect),
            null,
            16
            /* FULL_PROPS */
          ),
          createElementVNode(
            "div",
            {
              class: normalizeClass(["ui-steps-container", { "ui-active": unref(currentPage) == "end" }]),
              style: normalizeStyle(unref(style))
            },
            [
              withDirectives(createElementVNode(
                "input",
                mergeProps({
                  class: "ui-form-control ui-steps-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.modelValue.end = $event)
                }, unref(binds).input.end, toHandlers(unref(ons).end, true)),
                null,
                16
                /* FULL_PROPS */
              ), [
                [vModelDynamic, _ctx.modelValue.end]
              ]),
              withDirectives(createElementVNode(
                "input",
                mergeProps({
                  class: "ui-form-control ui-steps-number",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.modelValue["end-steps"] = $event)
                }, unref(binds).number, toHandlers(unref(ons).end, true)),
                null,
                16
                /* FULL_PROPS */
              ), [
                [vModelDynamic, _ctx.modelValue["end-steps"]]
              ])
            ],
            6
            /* CLASS, STYLE */
          )
        ],
        16
        /* FULL_PROPS */
      );
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
